<template>
    <NuxtLayout>
        <div class="mx-auto px-3">
            <ShcUiFormRegister
                v-if="!isSuccess"
                :agreements="agreements"
                :minimum-password-length="passwordValidationRules?.minimumPasswordLength"
                :number-of-required-character-classes="passwordValidationRules?.numberOfRequiredCharacterClasses"
                @customer-register="createCustomer"
            />
            <div v-else class="text-center">
                <ShcUiHeading class="mb-[84px] font-semibold lg:text-[28px] text-left" :tag="HEADING_TAG.h1">
                    {{ $t('Bbk.form.register.confirmation') }}
                </ShcUiHeading>
                <ShcUiParagraph class="!text-lg font-semibold">{{ $t('Bbk.form.register.linkSent') }}</ShcUiParagraph>
                <ShcUiIcon
                    class="text-white bg-bbk-mid-green rounded-full mx-auto !my-8 block w-10 text-[40px] leading-none"
                    name="check"
                />
                <ShcUiParagraph class="!text-xs">
                    {{ $t('Bbk.form.register.linkToConfirm') }}
                </ShcUiParagraph>
            </div>
        </div>
    </NuxtLayout>
</template>

<script lang="ts" setup>
    import { HEADING_TAG } from '@shc/nuxt-shc-ui-layer/components/Heading/heading'
    import type { Register } from '@/types/registration'
    import type { Query } from '@/graphql/types/graphql'
    import queryAgreementsCreateAccount from '@/graphql/queries/queryAgreementsCreateAccount.graphql'

    definePageMeta({
        middleware: ['login'],
    })

    const { $bus, $i18n } = useNuxtApp()

    const isSuccess = ref(false)
    const captchaToken = ref('')

    const { data: agreementsData } = await useAsyncQuery<Query>(queryAgreementsCreateAccount)

    const agreementsCreateAccount = agreementsData.value.agreementsCreateAccount
    const customerRegistrationAgreements = agreementsCreateAccount?.customerRegistrationAgreements
    const newsletterAgreements = agreementsCreateAccount?.newsletterAgreements

    const passwordValidationRules = agreementsCreateAccount?.password

    const agreements =
        customerRegistrationAgreements && newsletterAgreements
            ? customerRegistrationAgreements?.concat(newsletterAgreements)
            : []

    function createCustomer(data: Register) {
        $bus.$emit('customerCreate', {
            ...data,
            headers: {
                'X-ReCaptcha': captchaToken.value,
            },
        })
    }

    $bus.$on('customerCreateSuccess', () => {
        isSuccess.value = true
        window.scrollTo(0, 0)
    })

    onMounted(async () => {
        const recaptcha = useCaptcha()

        captchaToken.value = await recaptcha('register')

        $bus.$on('customerError', async () => {
            captchaToken.value = await recaptcha('register')
        })
    })

    useHead({
        title: $i18n.t('Bbk.form.register.title'),
        meta: [
            {
                hid: 'robots',
                name: 'robots',
                content: 'noindex',
            },
        ],
    })
</script>
